// Common Components
import { Button, DynamicDropdown, TextInput } from "src/Components";
// Requests
import { getCashAssetDropdown } from "src/Requests/goldArbitrage";
// Types
import { GoldPositionWatchListSearchParams } from "src/Interfaces/goldArbitrage";

interface IProps {
  searchParamChangeHandler: (name: string, value: any) => void;
  searchParam: GoldPositionWatchListSearchParams;
  onSubmit: () => void;
}

const SearchParamUI = ({
  searchParam,
  searchParamChangeHandler,
  onSubmit,
}: IProps) => {
  return (
    <div className="border border-gray-300 rounded p-3 grid grid-cols-1 gap-3 !w-[220px] !min-w-[220px]">
      <DynamicDropdown
        dropdown={{
          name: "srcInstrumentID",
          placeholder: "سهم مبدا",
          extraLabel: true,
        }}
        getData={getCashAssetDropdown}
        onChange={searchParamChangeHandler}
        value={searchParam.srcInstrumentID}
      />
      <TextInput
        label="حداقل حباب"
        onChange={searchParamChangeHandler}
        name="minBubble"
        value={searchParam.minBubble?.toString()}
        extraLabel
        kind="negativeDecimalNumbers"
      />
      <Button onClick={onSubmit} text="جستجو" variant="contained" />
    </div>
  );
};

export default SearchParamUI;
